import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webReview`

console.log('serverUrl', serverUrl)

export const addCustomerReviewApi = (formData) => {
    return axiosInstance.post(`${serverUrl}/addReview`, formData)
}

export const getCustomerReviewApi = (query = "") => {
    return axiosInstance.get(`${serverUrl}/getReviews`)
}

export const deleteCustomerReviewApi = (id) => {
    return axiosInstance.delete(`${serverUrl}/deleteReview/${id}`)
}

const CustomerReviewService = {
    addCustomerReview: addCustomerReviewApi,
    getCustomerReviews: getCustomerReviewApi,
    deleteCustomerReview: deleteCustomerReviewApi
}

export default CustomerReviewService
